export default "__VITE_ASSET__77cfa964__"